import { render, staticRenderFns } from "./SettingsAPP.vue?vue&type=template&id=52b59d94&scoped=true&"
import script from "./SettingsAPP.vue?vue&type=script&lang=js&"
export * from "./SettingsAPP.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAPP.vue?vue&type=style&index=0&id=52b59d94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b59d94",
  null
  
)

export default component.exports